import {useEffect} from 'react';
// La instancia global, no `useTranslation`: el marco lo montan decenas de suites que mockean
// `react-i18next`, y sin i18next inicializado (o sin idioma guardado) esto no hace nada.
import i18next from 'i18next';
import {LocalStorage} from '../utils/LocalStorage';
import {pendingUserLanguage} from '../components/portal/portalLanguage';

// Aplica el idioma del usuario logueado si la pantalla está en otro.
//
// El login lo guarda en LocalStorage pero no llama a `changeLanguage`, y el detector de i18next lee
// esa clave sólo al cargar la página: quien entraba sin recargar veía la app en el idioma con que
// había abierto la pantalla de login. Lo usa el marco de la agencia (`LayoutSidebar`), que montan
// todas sus pantallas; el portal lo resuelve en `LayoutPortal`, antes de dibujar el contenido.
// Cambiar el idioma desde el perfil también actualiza la clave guardada (el detector la cachea),
// así que esto nunca vuelve al idioma anterior.
export function useApplyUserLanguage() {
    useEffect(() => {
        if (!i18next.isInitialized) return;
        const language = pendingUserLanguage(i18next, LocalStorage.fetchUserLanguage());
        if (language !== null) i18next.changeLanguage(language);
    }, []);
}
